import { UatraitsState } from '../../../../types/common';

class Browser {
    private _ua: UatraitsState;

    constructor(ua: UatraitsState) {
        this._ua = ua;
    }

    isChromiumBased() {
        return this._ua.BrowserBase === 'Chromium';
    }

    isFirefox() {
        return ['Firefox', 'MobileFirefox'].includes(this._ua.BrowserName);
    }

    isSafariBased() {
        return this._ua.BrowserBase === 'Safari' || ['Safari', 'MobileSafari'].includes(this._ua.BrowserName);
    }

    isMobile() {
        return this._ua.isMobile;
    }

    isHeadlessChrome() {
        return this._ua.BrowserName === 'HeadlessChrome';
    }
}

let _browser: Maybe<Browser>;

export const initBrowser = (ua: UatraitsState) => {
    _browser = new Browser(ua);
};

export const browser = () => _browser;

export const supportsP2P = () => false;
export const shouldTrackAppStateChange = () => !browser?.()?.isFirefox() && !browser?.()?.isSafariBased();
export const isSimulcastEnabled = () => !browser?.()?.isFirefox();
export const supportsDeviceChange = () => !browser?.()?.isFirefox();
export const supportsVirtualBackground = () => !browser()?.isFirefox() && !browser()?.isSafariBased();
